import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from '@tanstack/react-router';

const NetworkError = ({ error, retry }) => {
  const isApiError = error?.response?.status;
  const statusCode = error?.response?.status;
  const errorMessage = error?.response?.data?.message || error?.message || 'Network error occurred';

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          {isApiError ? `Error ${statusCode}` : 'Network Error'}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {errorMessage}
        </Typography>
        <Box sx={{ mt: 2 }}>
          {retry && (
            <Button variant="contained" color="primary" onClick={retry} sx={{ mr: 2 }}>
              Try Again
            </Button>
          )}
          <Button component={Link} to="/" variant="outlined" color="primary" sx={{ mr: 2 }}>
            Go to Home
          </Button>
          <Button component={Link} to="/contact" variant="outlined" color="primary">
            Contact Support
          </Button>
        </Box>
        {process.env.NODE_ENV === 'development' && error && (
          <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1, textAlign: 'left' }}>
            <Typography variant="subtitle2" color="error">
              {error.toString()}
            </Typography>
            {error.response?.data && (
              <Typography variant="caption" component="pre" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
                {JSON.stringify(error.response.data, null, 2)}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default NetworkError;
